import { Box, Grid } from '@mui/material'
import { SectionHeader } from '@react/components/common/SectionHeader'
import ViewField from '@react/components/elements/ViewField'
import { fetchCollateral } from '@react/fetchers/collateralFetchers'
import { useOtChainState, useOtSelector } from '@react/redux/store'
import {
  CollateralSetCTO,
  CollateralSetSchema,
  DefiCollateralCTO,
  DefiCollateralSchema,
} from '@shared/CollateralSetCTO'

import { EthAddr } from '@shared/SchemaTypes'
import React, { useEffect, useState } from 'react'

type Props = {
  poolAddr: EthAddr
}

export default function DefiCollateralView({ poolAddr }: Props): React.ReactElement {
  const {
    stageConfiguration: { serverApiBaseUrl, restAPIKey },
  } = useOtChainState()
  const [collateralSetCTO, setCollateralSetCTO] = useState<CollateralSetCTO | null>(null)

  const fetchAndSetCollateral = () => {
    if (poolAddr && serverApiBaseUrl && restAPIKey) {
      fetchCollateral(serverApiBaseUrl, restAPIKey, poolAddr).then((_collateralSetCTO) => {
        if (_collateralSetCTO) {
          setCollateralSetCTO(_collateralSetCTO)
        }
      })
    }
  }
  const poolOverviewCTO = useOtSelector((state) => state.poolState.poolOverviewCTOs[poolAddr])
  const poolTokenSymbol = poolOverviewCTO?.symbol ?? ''
  const liquidityTokenSymbol = poolOverviewCTO?.liquidityTokenSymbol ?? ''

  useEffect(() => {
    fetchAndSetCollateral()
  }, [poolAddr, serverApiBaseUrl, restAPIKey])

  const defiCollateralCTO = collateralSetCTO?.collateral[0] as DefiCollateralCTO

  if (!defiCollateralCTO) {
    return <></>
  }
  if (!collateralSetCTO) {
    return <></>
  }
  return (
    <Box sx={{ p: 2, position: 'relative' }}>
      <SectionHeader>Defi Collateral</SectionHeader>

      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid item xs={12} sm={6}>
          <ViewField
            fieldSchema={DefiCollateralSchema.describe().fields.defiType}
            dataObject={defiCollateralCTO}
            poolTokenSymbol={poolTokenSymbol}
            liquidityTokenSymbol={liquidityTokenSymbol}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ViewField
            fieldSchema={CollateralSetSchema.describe().fields.exchangeRateAutomation}
            dataObject={collateralSetCTO as CollateralSetCTO}
            poolTokenSymbol={poolTokenSymbol}
            liquidityTokenSymbol={liquidityTokenSymbol}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ViewField
            fieldSchema={DefiCollateralSchema.describe().fields.transferWalletAddr}
            dataObject={defiCollateralCTO}
            poolTokenSymbol={poolTokenSymbol}
            liquidityTokenSymbol={liquidityTokenSymbol}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ViewField
            fieldSchema={DefiCollateralSchema.describe().fields.defiVaultAddr}
            dataObject={defiCollateralCTO}
            poolTokenSymbol={poolTokenSymbol}
            liquidityTokenSymbol={liquidityTokenSymbol}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ViewField
            fieldSchema={DefiCollateralSchema.describe().fields.calibrationWalletAddr}
            dataObject={defiCollateralCTO}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ViewField
            fieldSchema={DefiCollateralSchema.describe().fields.feeVaultWalletAddr}
            dataObject={defiCollateralCTO}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ViewField
            fieldSchema={DefiCollateralSchema.describe().fields.liquidityAssetAddr}
            dataObject={defiCollateralCTO}
            poolTokenSymbol={poolTokenSymbol}
            liquidityTokenSymbol={liquidityTokenSymbol}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ViewField
            fieldSchema={DefiCollateralSchema.describe().fields.nativeDefiExchangeRateScale}
            dataObject={defiCollateralCTO}
            poolTokenSymbol={poolTokenSymbol}
            liquidityTokenSymbol={liquidityTokenSymbol}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ViewField
            fieldSchema={DefiCollateralSchema.describe().fields.exchangeRateMinimumMaterialChange}
            dataObject={defiCollateralCTO}
            liquidityTokenSymbol={liquidityTokenSymbol}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ViewField
            fieldSchema={DefiCollateralSchema.describe().fields.exchangeRateMaximumAutoChange}
            dataObject={defiCollateralCTO}
            poolTokenSymbol={poolTokenSymbol}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ViewField
            fieldSchema={DefiCollateralSchema.describe().fields.resolvedVariance}
            dataObject={defiCollateralCTO}
            poolTokenSymbol={poolTokenSymbol}
            liquidityTokenSymbol={liquidityTokenSymbol}
          />
        </Grid>

        {/*
        <Grid item xs={12} sm={6}>
          <TextField
            {...register('marketValue', {
              required: 'Market Value is required',
              min: { value: 0, message: 'Market Value must be non-negative' },
            })}
            label="Market Value"
            required
            type="number"
            inputProps={{ step: '0.01' }}
            fullWidth
            error={!!errors.marketValue}
            helperText={errors.marketValue?.message}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            {...register('yieldOrCoupon', {
              required: 'Yield/Coupon is required',
              valueAsNumber: true,
              min: { value: 0, message: 'Yield/Coupon must be non-negative' },
            })}
            label="Yield/Coupon (%)"
            required
            type="number"
            inputProps={{ step: '0.01' }}
            fullWidth
            error={!!errors.yieldOrCoupon}
            helperText={errors.yieldOrCoupon?.message}
          />
        </Grid> */}
      </Grid>
    </Box>
  )
}
